import React from 'react';

const ComposerContext = React.createContext({
  reply: '',
  setReply: () => {}
});

export default ComposerContext;
